import React, { useContext } from "react";
import { useConverters } from "./../../pm-converters/context";
import { TIPTAP_FIGURE_TYPE } from "./../../ricos-content/consts";
import { RicosContext } from "./../../ricos-context";
import { Loader, MediaItemErrorMsg } from "./../../ui-components";
import { getContainerClasses } from "../../_shared/figure/get-container-classes";
import { Image as ViewerImage } from "../viewer/image";
const Image = ({ node, editor }) => {
  const { t, isMobile } = useContext(RicosContext);
  const converters = useConverters();
  const figures = editor.$nodes(TIPTAP_FIGURE_TYPE);
  const selectedFigure = figures?.find((nodePos) => {
    return nodePos.node.firstChild?.attrs.id === node.attrs.id;
  })?.node;
  const { loading, loadingPercentage, error, tempData } = node.attrs;
  const { src } = node.attrs.image || {};
  const shouldRender = !!tempData || src?.url || src?.id;
  const ricosNode = converters.fromPmNode(selectedFigure?.toJSON());
  return selectedFigure && ricosNode && shouldRender ? /* @__PURE__ */ React.createElement(
    "div",
    {
      className: getContainerClasses(editor, node.attrs.id, isMobile),
      draggable: true,
      "data-drag-handle": true
    },
    /* @__PURE__ */ React.createElement(
      ViewerImage,
      {
        isMobile,
        node: ricosNode,
        dataUrl: tempData,
        imageClickActionConfig: { type: "regular" },
        shouldLazyLoadImages: false
      }
    ),
    loading && /* @__PURE__ */ React.createElement(Loader, { type: "medium", percent: loadingPercentage }),
    error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error, t })
  ) : null;
};
export {
  Image
};
//# sourceMappingURL=image.js.map
